import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=cd8f9e9a&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"
import style1 from "./Projects.vue?vue&type=style&index=1&id=cd8f9e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8f9e9a",
  null
  
)

export default component.exports